export const translations = {
  sv: {
    heading: 'Prisindikation med PEX Bud',
    labelFrom: 'Från postkod',
    labelTo: 'Till postkod',
    zipPlaceholder: 'Ex. 12831',
    labelWeight: 'Vikt (i kilo)',
    weightPlaceholder: 'Ex. 1000',
    labelWhen: 'När',
    submitButtonText: 'Beräkna pris',
  },
  en: {
    heading: 'Calculate price with PEX Bud',
    labelFrom: 'From zip',
    labelTo: 'To zip',
    zipPlaceholder: 'Ex. 12831',
    labelWeight: 'Weight (in kilo)',
    weightPlaceholder: 'Ex. 1000',
    labelWhen: 'When',
    submitButtonText: 'Calculate price',
  },
};
